export function isLaboratorySelectDisabled({ selectedProtocol }: { selectedProtocol: unknown }): boolean {
    return selectedProtocol != null;
}

export function isProtocolSelectDisabled(
    { selectedLaboratory, protocolsCount, itemsCount }: { selectedLaboratory: unknown; protocolsCount: number; itemsCount: number }
): boolean {
    return (selectedLaboratory === null || !(protocolsCount > 0)) || itemsCount > 0;
}

export function isClearDisabled(
    { selectedLaboratory, selectedProtocol, itemsCount }: { selectedLaboratory: unknown; selectedProtocol: unknown; itemsCount: number }
): boolean {
    return (selectedLaboratory == null && selectedProtocol == null) || itemsCount > 0;
}
